<template>
  <v-form v-model="valid" ref="form">

    <v-container fluid class="pr-6 mt-4" @click="selectedItem = null">
      <v-row>
        <v-col cols="6" sm="4" md="3">
          <date-picker label="As of" v-model="item.initialAsof"/>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" lg="10">
          <outlined-block title="Initial quantities/values for new items" :rules="[initValid]">
            <v-data-table width="100%" calculate-widths disable-filtering disable-pagination disable-sort hide-default-footer
                          :items="item.initial" no-data-text="No items specified"
                          :headers="headers" class="no-sort"
                          :item-class="item => item.id=== selectedItem ? ($vuetify.theme.dark ? 'grey darken-1' : 'grey lighten-4') : ''"
                          @click.native.stop=""
                          @click:row="item => {selectedItem = item.id; $nextTick(() => this.$refs.form.validate())}">
              <template v-slot:item.add="{index}">
                <v-btn class="mt-n2" icon @click.stop="deleteItem(index)"><v-icon small>mdi-delete</v-icon></v-btn>
              </template>
              <template v-slot:item.site="{item}">
                <v-autocomplete v-if="selectedItem === item.id" :items="sites" v-model="item.siteId" dense item-text="name" item-value="id" outlined label="Site"/>
                <div v-else class="ml-1">{{siteName(item.siteId)}}</div>
              </template>
              <template v-slot:item.lot="{item}">
                <v-text-field v-if="selectedItem === item.id" v-model="item.lot" dense :rules="[fieldRules.required]" outlined label="Lot"/>
                <div v-else class="ml-1" :class="{'error--text':!item.lot}">{{item.lot || 'Required'}}</div>
              </template>
              <template v-slot:item.quantity="{item:listItem}">
                <decimal-number-input v-if="selectedItem === listItem.id" label="Quantity" dense v-model="listItem.quantity" prefix="" :suffix="item.trackUnits" :precision="item.precision" :no-minimum="item.allowNegativeInventory"/>
                <div v-else class="mr-1" :class="{'error--text':listItem.quantity<0 && !item.allowNegativeInventory}">{{listItem.quantity | number(item.precision)}} {{item.trackUnits}}</div>
              </template>
              <template v-slot:item.value="{item:listItem}">
                <decimal-number-input v-if="selectedItem === listItem.id" label="Value" dense v-model="listItem.value" :no-minimum="item.allowNegativeInventory"/>
                <div v-else class="mr-1" :class="{'error--text':listItem.value<0 && !item.allowNegativeInventory}">{{listItem.value | currency}}</div>
              </template>
              <template v-slot:body.append="{headers}">
                <tr class="no-hover" @click="selectedItem = null">
                  <td class="text-center">
                    <v-btn fab color="primary" x-small @click.stop="addItem"><v-icon small>mdi-plus</v-icon></v-btn>
                  </td>
                  <td :colspan="headers.length-1" class="text-caption text-right">
                    <sup>*</sup>Values are total values for the added inventory, not unit cost
                  </td>
                </tr>
              </template>
            </v-data-table>
          </outlined-block>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
export default {
  name: 'InventoryItemsEditInit',
  props: {
    item: {type:Object, required:true}
  },
  data() {
    return {
      valid: true,
      selectedItem: null
    }
  },
  computed: {
    sites() {
      return this.$store.getters.sites(true);
    },
    headers() {
      const headers = [{text:'',value:'add',width:'5%',align:'center',cellClass:'pa-0',divider:true}];
      if (this.sites.length > 1)
        headers.push({text:'Site',value:'site',width:'40%',divider:true,class:'px-2',cellClass:'py-2 px-1'});
      if (this.item.lotTracking)
        headers.push({text:'Lot #',value:'lot',width:'20%',divider:true,class:'px-2',cellClass:'py-2 px-1'});
      return [...headers, {text:'Quantity',value:'quantity',width:'20%',divider:true,class:'px-2',cellClass:'py-2 px-1',align:'right'},
                          {text:'Value *',value:'value',width:'15%',divider:true,class:'px-2',cellClass:'py-2 px-1',align:'right'}];
    },
    initValid() {
      return this.item.initial.every(item => (!!item.lot || !this.item.lotTracking) && (this.item.allowNegativeInventory || (item.quantity >= 0 && item.value >= 0)));
    }
  },
  created() {
    this.valid = this.initValid;
  },
  methods: {
    siteName(siteId) {
      return this.sites.find(site => site.id === siteId)?.name;
    },
    async addItem() {
      const results = await this.$apiCall(`query InventoryItemsEditInit {
                                              lotUnique(prefix:"I")
                                            }`,
                                        {});
      if (!results.error) {
        const item = {siteId:this.sites[0].id,lot:results.data.lotUnique,quantity:0,value:0,id:Date.now()};
        this.item.initial.push(item);
        this.selectedItem = item.id;
      }
      this.$nextTick(() => {
        this.$refs.form.validate();
      });
    },
    deleteItem(index) {
      this.item.initial.splice(index, 1);
    }
  }
}
</script>